import { Component } from '@angular/core';
import { AdminService } from '../../admin.service';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-toolbar',
    templateUrl: './admin-toolbar.component.html',
    styleUrls: ['./admin-toolbar.component.scss'],
    standalone: false
})
export class AdminToolbarComponent extends AdminActionsDirective {
    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}
